import PropTypes from "prop-types";

const LinkedinIcon = ({ color = "white", bgColor = "#7B9E7E" }) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.521484"
        y="0.258301"
        width="29.9111"
        height="29.9111"
        rx="4.78577"
        fill={bgColor}
      />
      <path
        d="M9.32276 11.1853C10.5506 11.1853 11.5459 10.19 11.5459 8.96217C11.5459 7.73435 10.5506 6.73901 9.32276 6.73901C8.09495 6.73901 7.09961 7.73435 7.09961 8.96217C7.09961 10.19 8.09495 11.1853 9.32276 11.1853Z"
        fill={color}
      />
      <path
        d="M11.01 12.6675H7.63664C7.54499 12.6675 7.4707 12.7418 7.4707 12.8334V23.6164C7.4707 23.7081 7.54499 23.7824 7.63664 23.7824H11.01C11.1017 23.7824 11.176 23.7081 11.176 23.6164V12.8334C11.176 12.7418 11.1017 12.6675 11.01 12.6675Z"
        fill={color}
      />
      <path
        d="M23.7731 16.7427V23.0412C23.7731 23.4486 23.4395 23.7822 23.032 23.7822H20.8089C20.4014 23.7822 20.0678 23.4486 20.0678 23.0412V17.8538C20.0678 16.8313 19.2382 16.0016 18.2157 16.0016C17.1931 16.0016 16.3635 16.8313 16.3635 17.8538V23.0412C16.3635 23.4486 16.0299 23.7822 15.6224 23.7822H13.3993C12.9918 23.7822 12.6582 23.4486 12.6582 23.0412V13.4075C12.6582 13.0001 12.9918 12.6665 13.3993 12.6665H15.6224C16.0299 12.6665 16.3635 13.0001 16.3635 13.4075V13.8819C17.1045 12.9219 18.3312 12.2964 19.6978 12.2964C21.7428 12.2964 23.7731 13.7785 23.7731 16.7427Z"
        fill={color}
      />
    </svg>
  );
};

const { string } = PropTypes;

LinkedinIcon.propTypes = {
  color: string,
  bgColor: string
};

export default LinkedinIcon;
